const channelId = /^[CG][A-Z0-9]{8,20}$/i;

/** Accept copied channel links while preserving existing saved channel IDs. */
export function channelIdFromSlackLink(input: string): string | null {
  const value = input.trim();
  if (channelId.test(value)) return value.toUpperCase();

  try {
    const url = new URL(value);
    if (url.protocol !== "https:" || !url.hostname.endsWith(".slack.com")) {
      return null;
    }
    const match = url.pathname.match(
      /^\/(?:archives\/|client\/[^/]+\/)([CG][A-Z0-9]{8,20})(?:\/|$)/i,
    );
    return match?.[1].toUpperCase() ?? null;
  } catch {
    return null;
  }
}
